import http from "../http";

const ExternalProjectService = {
    getExternalInfosService: async () => {
        const segments = await http.instance.get("/external/externalinfos");
        return segments.data
    },

    getExternalInfoService: async (userId, projectCode) => {
        const segment = await http.instance.get("/external/externalinfo/" + userId + "/" + projectCode)
        return segment.data;
    },
    AddExternalInfoService: async (form) => {
        const segment = await http.instance.post("/external/externalpost", form)
        return segment;
    }
};
export default ExternalProjectService;
